export type DateTimePreset =
  | 'dateTime' // 24 May 2026, 17:17
  | 'dayMonthTime' // 24 May, 17:17 (task cards)
  | 'date' // 24 May 2026
  | 'dayMonthYearLong' // 24 May 2026 (news dates)
  | 'newsDate' // 24 May [2026] — year only when not current
  | 'monthYear' // May 2026 (marquee, forClubs)

/**
 * Forced on every preset: Gregorian calendar + Latin digits.
 * Without this, locales like `fa`/`ar` would render a Persian/Hijri calendar
 * and non-Latin numerals, diverging from Arena's date design (OCE-1226, D-5).
 */
export const BASE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  calendar: 'gregory',
  numberingSystem: 'latn'
}

/** Intl options per preset. `newsDate` is computed dynamically (conditional year). */
export const PRESET_OPTIONS: Record<
  Exclude<DateTimePreset, 'newsDate'>,
  Intl.DateTimeFormatOptions
> = {
  dateTime: {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  },
  dayMonthTime: {
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit'
  },
  date: {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  },
  dayMonthYearLong: {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  },
  monthYear: {
    month: 'short',
    year: 'numeric'
  }
}
